import styles from './index.module.scss'

const Card1 = () => {

   return (
     <div className='w-1340'>
       <div className={`flex ${styles.card} flex-just flex-wrap`}>
         <div className={`flex ${styles.boxContent}`} >
           Vishwa pioneered trustless orchestration.<br />
           Now, for partners who require compliant custody, we also offer regulated custodial pathways, all within the same orchestration layer.
         </div>
       </div>
     </div>

   )
}

export default Card1